module.exports = __webpack_public_path__ + "img/pk.c3ec4436.png";